import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import './style.scss';
import Constants from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import Shopify from '@Images/admin/integrations/shopify.png';
import H3Image from '@Uilib/h3Image';

/**
 *
 */
function ShopifyHome({
  getShopifyConnections, user, getShopifyConnectionsLoading, connectToShopifyLoading,
}) {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [shopName, setShopName] = React.useState('');

  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id);
  }, []);

  return (
    <div className="shopify-integration-wrapper">
      <div className="shopify-integration__heading">Shopify Integration </div>

      { !getShopifyConnectionsLoading ? (
        <React.Fragment>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="shopify-connect__wrapper">
              <H3Image src={Shopify} className="shopify-connect__image" />
              <div className="shopify-connect__header">Connect Your Shopify account to Procuzy. Please Enter your Shopify store address to get started.</div>
              <div className="shopify-input-action__wrapper">
                <div className="shopify-input-action">
                  <H3FormInput
                    name="Enter Shop Name"
                    type="text"
                    containerClassName="orgInputContainer create__right-input"
                    labelClassName="orgFormLabel"
                    inputClassName="shopNameInput"
                    placeholder="your-store-address"
                    onChange={(value) => {
                      setShopName(value.target.value);
                    }}
                    disabled={connectToShopifyLoading}
                    value={shopName}
                    maxlength="100"
                    required
                    showError={formSubmitted && shopName?.length === 0}
                  />
                </div>
                <div>.myshopify.com</div>
              </div>
              <div>
                <H3Button
                  text="Authorize"
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  onClick={() => {
                    setFormSubmitted(true);
                    window.location.href = `${Constants.CONNECT_TO_SHOPIFY}?shop=${shopName}.myshopify.com&org_id=${user?.tenant_info?.org_id}&redirect_uri=${window.location.protocol}//${window.location.host}/admin/integration/shopify`;
                  }}
                  customClass="shopify-connect__location-submit"
                  isLoading={getShopifyConnectionsLoading}
                  disabled={getShopifyConnectionsLoading}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          className="shopify-list-wrapper"
        >
          {

            [1, 2, 3].map((item) => (
              <div
                key={item}
                className="loading-shopify__card"
              >
                <div className="shopify-card-spacing">

                  <div className="shopify-card-header ">

                    <div className="loadingBlock loading-shopify-header__text" />
                    <div className="loadingBlock loading-shopify-header__image"> </div>
                  </div>

                  <div className="loadingBlock loading-shopify-card__link"> </div>
                  <div className="shopify-card-footer">
                    <div
                      className="flex "
                    >
                      <p className="loadingBlock loading-shopify-card__footer" />
                    </div>
                  </div>
                </div>
              </div>

            ))

          }

        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ ShopifyIntegrationReducers, UserReducers }) => ({
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  getShopifyConnectionsLoading: ShopifyIntegrationReducers.getShopifyConnectionsLoading,
  user: UserReducers.user,
});
const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectToShopify: (orgId, callback) => dispatch(ShopifyIntegrationActions.connectToShopify(orgId, callback)),

});
ShopifyHome.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  shopifyConnections: PropTypes.any,
  getShopifyConnections: PropTypes.func,
  getShopifyConnectionsLoading: PropTypes.bool,
  connectToShopifyLoading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyHome));
